





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Notification } from '@/models/notification';

@Component({})
export default class NotificationWidget extends Vue {
  get notificationCount(): number {
    return this.notifications.length;
  }

  get notifications(): Notification[] {
    return this.$store.getters.unreadNotifications;
  }

  public showNotificationCenter() {
    document.getElementById('myDropdown')!.classList.toggle('show');
  }

  public markAsRead(item: Notification) {
    this.$store.commit('markNotificationRead', item);
  }

  private mounted() {
    //
  }
}

// Close the dropdown if the user clicks outside of it
// can be enabled to make clicking outside the area close the dialog
// window.onclick = (e) => {
//   if (!(e.target as Element)!.matches('.dropbtn')) {
//     const myDropdown = document.getElementById('myDropdown')!;
//     if (myDropdown.classList.contains('show')) {
//       myDropdown.classList.remove('show');
//     }
//   }
// };
